import { api } from './api.config';
import { SendMissingMatchesResponseDto } from '../generated/orval/schemas';

export const sendDuprResults = async () => {
  const response = await api.post<SendMissingMatchesResponseDto>('admin/dupr/send-missing-matches');
  return response.data;
};

export const getDuprClubIds = async () => {
  const response = await api.get<{
    userDuprId: string;
    clubDuprIds: { clubId: number; clubName: string; role: string }[];
  }>('dupr/ids');
  return response.data;
};

export const loginWithDupr = async () => {
  const response = await api.get<{ loginUrl: string; signUpUrl: string }>('dupr/login');
  return response.data;
};

export const patchUserDuprId = async (duprId: string) => {
  const response = await api.patch(`user/update`, { duprId });
  return response.data;
};
